module.exports = __webpack_public_path__ + "static/img/banner.989bd81f.png";